module.exports = __webpack_public_path__ + "img/bg-dark8.0f5c3cc6.jpg";